import userManagementMitraAPI from '@/api/master-data/user-management-mitra/user-management-mitra';

const state = {
  isLoading: false,
  userMitraData: [],
  totalRecords: 0,
  companies: []
};

const getters = {};

const mutations = {
  SET_LOADING(state, status) {
    state.isLoading = status;
  },
  SET_USER_MITRA_DATA(state, data) {
    state.userMitraData = data;
  },
  SET_TOTAL_RECORDS(state, total) {
    state.totalRecords = total;
  },
  SET_COMPANIES(state, companies) {
    state.companies = companies;
  }
};

const actions = {
  // Get user mitra list
  async getUserMitraList({ commit }, params) {
    commit('SET_LOADING', true);
    try {
      const response = await userManagementMitraAPI.getUserMitraList(params);
      if (response.data) {
        // API response structure: { data: [], totalItems, page, limit, totalPages }
        const users = response.data.data.data || [];
        const totalItems = response.data.data.totalItems || 0;
        
        commit('SET_USER_MITRA_DATA', users);
        commit('SET_TOTAL_RECORDS', totalItems);
      } else {
        commit('SET_USER_MITRA_DATA', []);
        commit('SET_TOTAL_RECORDS', 0);
      }
    } catch (error) {
      console.error('Get user list error:', error);
      commit('SET_USER_MITRA_DATA', []);
      commit('SET_TOTAL_RECORDS', 0);
      throw error;
    } finally {
      commit('SET_LOADING', false);
    }
  },

  // Search user by NIK (external API)
  async searchUserByNik({ commit }, params) {
    try {
      const response = await userManagementMitraAPI.searchUserByNik(params);
      
      // API returns data directly in response.data (array)
      if (response.data && Array.isArray(response.data)) {
        return response.data;
      }
      
      // If wrapped in data object
      if (response.data && response.data.data) {
        return response.data.data;
      }
      
      return [];
    } catch (error) {
      console.error('Search user error:', error);
      return [];
    }
  },

  // Get user detail by NIK
  async getUserDetailByNik({ commit }, nik) {
    commit('SET_LOADING', true);
    try {
      const response = await userManagementMitraAPI.getUserDetailByNik(nik);
      
      if (response.data) {
        // Return user data directly or from nested structure
        return response.data.data || response.data;
      }
      return null;
    } catch (error) {
      console.error('Get user detail error:', error);
      return null;
    } finally {
      commit('SET_LOADING', false);
    }
  },

  // Create user mitra
  async createUserMitra({ commit }, data) {
    commit('SET_LOADING', true);
    try {
      const response = await userManagementMitraAPI.createUserMitra(data);
      
      if (response.data && (response.data.httpCode == 201)) {
        return response.data;
      } else {
        throw new Error(response.data.message || 'Failed to create user');
      }
    } catch (error) {
      throw error;
    } finally {
      commit('SET_LOADING', false);
    }
  },

  // Update user mitra (using NIK)
  async updateUserMitra({ commit }, { nik, data }) {
    commit('SET_LOADING', true);
    try {
      const response = await userManagementMitraAPI.updateUserMitra(nik, data);
      
      if (response.data && response.data.httpCode == 200) {
        return response.data;
      } else {
        throw new Error(response.data.message || 'Failed to update user');
      }
    } catch (error) {
      throw error;
    } finally {
      commit('SET_LOADING', false);
    }
  },

  // Delete user mitra (using NIK)
  async deleteUserMitra({ commit }, nik) {
    commit('SET_LOADING', true);
    try {
      const response = await userManagementMitraAPI.deleteUserMitra(nik);
      
      if (response.data && response.data.httpCode == 200) {
        return response.data;
      } else {
        throw new Error(response.data.message || 'Failed to delete user');
      }
    } catch (error) {
      throw error;
    } finally {
      commit('SET_LOADING', false);
    }
  },

  // Get companies list
  async getCompaniesList({ commit }) {
    try {
      const response = await userManagementMitraAPI.getCompanies();
      
      if (response.data && response.data.data) {
        commit('SET_COMPANIES', response.data.data);
        return response.data.data;
      }
      return [];
    } catch (error) {
      console.error('Get companies error:', error);
      commit('SET_COMPANIES', []);
      return [];
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
